import { render, staticRenderFns } from "./DirectAction.vue?vue&type=template&id=0e73d046"
import script from "./DirectAction.vue?vue&type=script&lang=js"
export * from "./DirectAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports